<template>
  <div>
    <!-- <v-btn class="logout" icon color="error" @click="logout()">
      
    </v-btn> -->
    <div class="text-xs-center logout">
      <v-menu offset-y open-on-hover left>
        <v-btn color="amber lighten-1 elevation-0" dark slot="activator">
          <v-avatar class="orange">
            <v-icon dark>account_circle</v-icon>
          </v-avatar>
        </v-btn>
        <v-list class="user-menu">
          <v-list-tile color="black">
            <v-list-tile-title @click="showProfile()">
              <v-icon color="black">fa-user-circle</v-icon>
              Profil
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile color="red">
            <v-list-tile-title @click="logout()">
              <v-icon color="red">fa-sign-out</v-icon>
              Odhlásiť sa
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import router from '../router'

export default {
  name: 'Logout',
  methods: {
    ...mapMutations(['LOGOUT_USER']),
    logout () {
      localStorage.removeItem('token')
      this.$store.commit('LOGOUT_USER')
      router.push('/login')
    },
    showProfile: function () {
      this.$emit('showProfile')
    }
  }
}
</script>
<style scoped>
.logout {
  height: 100%;
}
.user-menu {
  border-radius: 0px !important;
  position: relative;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Logout.vue